function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    hide\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,25.43a1.41,1.41,0,1,1,0-2.81c9.8,0,15.66-9.59,15.72-9.69a1.41,1.41,0,0,1,2.42,1.45C37.86,14.83,31.38,25.43,20,25.43Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20,33a1.41,1.41,0,0,1-1.41-1.41V24a1.41,1.41,0,0,1,2.82,0v7.53A1.41,1.41,0,0,1,20,33Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30.55,30.07a1.41,1.41,0,0,1-1.25-.76L26,23a1.41,1.41,0,0,1,2.49-1.31L31.79,28a1.42,1.42,0,0,1-1.24,2.07Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38.29,24.3a1.41,1.41,0,0,1-.87-.3L31.9,19.7a1.41,1.41,0,1,1,1.73-2.23l5.53,4.3a1.42,1.42,0,0,1-.87,2.53Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20,25.43c-11.38,0-17.87-10.6-18.14-11a1.41,1.41,0,0,1,2.42-1.45c.06.1,6,9.69,15.72,9.69a1.41,1.41,0,1,1,0,2.81Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.45,30.07A1.42,1.42,0,0,1,8.21,28l3.31-6.28A1.41,1.41,0,1,1,14,23L10.7,29.31A1.41,1.41,0,0,1,9.45,30.07Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1.71,24.3a1.41,1.41,0,0,1-.86-2.53l5.52-4.3A1.41,1.41,0,0,1,8.1,19.7L2.58,24A1.41,1.41,0,0,1,1.71,24.3Z"
});

function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hide_svg__hide_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgHide;